module.exports = __webpack_public_path__ + "static/img/img_result_alert.d517729.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_result_alert.webp
// module id = 3S3R
// module chunks = 1